module.exports = __webpack_public_path__ + "static/media/defaultCoverPhoto.c0a9b7de.jpg";